
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if (audio_url != '') {
    ; __append("\n	<div class=\"news-audio clearfix\">\n		<div id=\"audio_")
    ; __append(escape(index))
    ; __append("\" class=\"liveaudio_container\" style=\"width: ")
    ; __append(escape(width))
    ; __append("%\"></div>\n		<div class=\"duration\">")
    ; __append(escape(audio_duration))
    ; __append("</div>\n	</div>\n")
    ; }
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/modules/f.component.audio.mobile/app/modules/audio/audio.ejs
// module id = 414
// module chunks = 0